import { gql } from 'graphql.macro'

export default gql`
  fragment ManufacturerFragment on Manufacturer {
    id
    name
    code
  }
`
